// import Cookies from 'js-cookie'
import { removeRememberAgreement } from '@/utils/agreement'
import { removeLastSync } from '@/utils/sync'

const TokenKey = 'token'

export function getToken() {
  // return Cookies.get(TokenKey)
  return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  // return Cookies.set(TokenKey, token, { expires: 365 })

  return localStorage.setItem(TokenKey, token)
}

export function setTokenRemember(token) {
  // return Cookies.set(TokenKey, token, { expires: 365 })

  return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  removeRememberAgreement()
  removeLastSync()

  // return Cookies.remove(TokenKey)
  return localStorage.removeItem(TokenKey)
}
